import axios from "axios";
import { HOST_URL } from "../bin/env";
import { REACT_APP_API_KEY } from "../bin/env";
// export const baseUrl = HOST_URL;

const axiosInstance = axios.create({
  baseURL: HOST_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
    "X-API-KEY": REACT_APP_API_KEY,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
